import { colors } from '@constants/colors';
import { IStyles } from '@interfaces/styles';

export const useStyles = (): IStyles => ({
  root: {
    margin: 0,
    padding: 0,
    width: 40,
    height: 40,
    borderRadius: '50%',
    backgroundColor: colors.black,
    transition: 'background-color 120ms ease',
    '&:hover': {
      backgroundColor: colors.black_second,
    },
    '& svg': {
      width: 24,
      height: 24,
      fontSize: 24,
      color: colors.white,
    },
  },
});
